(() => {
  const DEBUG = false;
  const log = (...a) => { if (DEBUG) console.log("[FILTER][ICON]", ...a); };

  const PROCESSED = new WeakSet();
  let debounceTimer = null;

  const norm = (s) => (s || "").replace(/\s+/g, " ").trim();

  function isVisible(el) {
    if (!el) return false;
    const cs = getComputedStyle(el);
    const r = el.getBoundingClientRect();
    return (
      cs.display !== "none" &&
      cs.visibility !== "hidden" &&
      parseFloat(cs.opacity) > 0 &&
      r.width > 0 &&
      r.height > 0
    );
  }

  function getItems() {
    let data = window.FILTER_ICON_TEXTS;
    if (typeof data === "string") {
      try { data = JSON.parse(data); } catch (e) { data = []; }
    }
    return Array.isArray(data) ? data : [];
  }

  function buildMap() {
    const map = new Map();
    getItems().forEach((it) => {
      const key = norm(it && it.begriff);
      if (!key) return;
      map.set(key, it.beschreibung || "");
    });
    return map;
  }

  function resolveMapping(titleText, dict) {
    const t = norm(titleText);
    if (!t) return null;

    // Titel ohne Klammern/Counts
    const noParen = t.replace(/\s*\(.*?\)\s*/g, "").trim();

    if (dict.has(t)) return { key: t, desc: dict.get(t) };
    if (dict.has(noParen)) return { key: noParen, desc: dict.get(noParen) };

    const tl = t.toLowerCase();
    const npl = noParen.toLowerCase();

    for (const k of dict.keys()) {
      const kl = k.toLowerCase();
      if (tl === kl || npl === kl || tl.startsWith(kl) || npl.startsWith(kl)) {
        return { key: k, desc: dict.get(k) };
      }
    }
    return null;
  }

  function getI18n() {
    const langRaw =
      (window.Shopify && Shopify.locale) ||
      document.documentElement.lang ||
      "en";
    const lang = String(langRaw).toLowerCase().split(/[-_]/)[0];

    const TEXT = {
      de: "Mehr Infos",
      en: "More info",
      fr: "Plus d\u2019infos",
      it: "Maggiori info",
      es: "M\u00e1s informaci\u00f3n",
      nl: "Meer info",
    };
    const ARIA = {
      de: (k) => `Mehr Infos zu ${k}`,
      en: (k) => `More info about ${k}`,
      fr: (k) => `Plus d\u2019infos sur ${k}`,
      it: (k) => `Maggiori info su ${k}`,
      es: (k) => `M\u00e1s informaci\u00f3n sobre ${k}`,
      nl: (k) => `Meer info over ${k}`,
    };
    return {
      text: TEXT[lang] || TEXT.en,
      aria: ARIA[lang] || ARIA.en,
    };
  }

  function openInfo(title, body) {
    if (typeof window.openPopupWith === "function") {
      window.openPopupWith(title, body);
      return;
    }
    const overlay = document.getElementById("custompopup1");
    if (!overlay) return;
    const h2 =
      overlay.querySelector("#custompopup1-title") ||
      overlay.querySelector("h2");
    const content = overlay.querySelector(".custompopup-content");
    if (h2) h2.textContent = title || "";
    if (content) content.innerHTML = body || "";
    if (typeof window.openPopup === "function") {
      window.openPopup();
    } else {
      overlay.classList.add("is-open");
      overlay.setAttribute("aria-hidden", "false");
      document.body.classList.add("custompopup-no-scroll");
    }
  }

  function injectIntoScope(scope, dict) {
    if (!scope) return;

    // Desktop / horizontale Facets: .facets__summary-label
    const labelSpans = scope.querySelectorAll(".facets__summary-label");
    labelSpans.forEach((labelSpan) => {
      if (!isVisible(labelSpan)) return;
      if (PROCESSED.has(labelSpan)) return;

      const clone = labelSpan.cloneNode(true);
      clone.querySelectorAll(".facets__selected").forEach((n) => n.remove());
      const titleText = norm(clone.textContent || "");
      if (!titleText) return;

      const match = resolveMapping(titleText, dict);
      if (!match) return;

      const { key: matchedKey, desc } = match;
      const { text: infoText, aria: ariaFn } = getI18n();

      // Button ggf. wiederverwenden
      let btn =
        labelSpan.parentElement &&
        labelSpan.parentElement.querySelector(".snize-info-icon");
      if (!btn) {
        btn = document.createElement("button");
        btn.type = "button";
        btn.className = "snize-info-icon";
        btn.setAttribute("aria-label", ariaFn(matchedKey));
        btn.setAttribute("aria-haspopup", "dialog");

        btn.innerHTML =
          '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M12 2a10 10 0 1 0 .001 20.001A10 10 0 0 0 12 2zm0 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm1 9h-2v-8h2v8z"></path></svg>' +
          '<span class="snize-info-text" style="line-height:1;">' +
          infoText +
          "</span>";

        // Grund-Styles (durch CSS-Klasse überschreibbar)
        const baseColor =
          getComputedStyle(document.documentElement)
            .getPropertyValue("--sr-info-color")
            .trim() || "#6b6b6b";
        const hoverColor =
          getComputedStyle(document.documentElement)
            .getPropertyValue("--sr-info-hover")
            .trim() || "#1e40af";

      

        // Schrift & Höhe an Label anpassen
const labelStyles = labelSpan ? getComputedStyle(labelSpan) : null;

btn.style.marginLeft = "8px";
btn.style.marginRight = "0";
btn.style.display = "inline-flex";
btn.style.alignItems = "center";
btn.style.gap = "6px";
btn.style.border = "1px solid transparent";
btn.style.borderRadius = "8px";
btn.style.background = "transparent";
btn.style.color = baseColor;
btn.style.cursor = "pointer";

// vertikal keine Extra-Höhe
btn.style.paddingTop = "0";
btn.style.paddingBottom = "0";
// etwas horizontaler Abstand für Klickfläche
btn.style.paddingLeft = "6px";
btn.style.paddingRight = "6px";

// Schrift vom Label übernehmen
btn.style.fontSize = labelStyles ? labelStyles.fontSize : "inherit";
btn.style.lineHeight = labelStyles ? labelStyles.lineHeight : "inherit";


        const applyHover = (on) => {
          btn.style.color = on ? hoverColor : baseColor;
          btn.style.backgroundColor = on ? "rgba(30,64,175,.08)" : "transparent";
          btn.style.borderColor = on ? "rgba(30,64,175,.35)" : "transparent";
          btn.style.outline = on ? "none" : "";
        };
        btn.addEventListener("mouseenter", () => applyHover(true));
        btn.addEventListener("mouseleave", () => applyHover(false));
        btn.addEventListener("focus", () => applyHover(true));
        btn.addEventListener("blur", () => applyHover(false));

        // direkt rechts neben dem Label-Text
        labelSpan.insertAdjacentElement("afterend", btn);
      }

      if (!btn.dataset.bound) {
        btn.addEventListener("click", (ev) => {
          ev.stopPropagation();
          openInfo(matchedKey, desc);
        });
        btn.dataset.bound = "1";
      }

      PROCESSED.add(labelSpan);
      log(`Icon/Mehr-Infos gesetzt an "${titleText}" → "${matchedKey}"`);
    });

    // Optional: mobile Drawer (.mobile-facets__label)
    const mobileLabels = scope.querySelectorAll(
      ".mobile-facets__label span[aria-hidden='true']"
    );
    mobileLabels.forEach((span) => {
      if (!isVisible(span)) return;
      if (PROCESSED.has(span)) return;

      const titleText = norm(span.textContent || "");
      if (!titleText) return;

      const match = resolveMapping(titleText, dict);
      if (!match) return;

      const { key: matchedKey, desc } = match;
      const { text: infoText, aria: ariaFn } = getI18n();

      let btn =
        span.parentElement &&
        span.parentElement.querySelector(".snize-info-icon");
      if (!btn) {
        btn = document.createElement("button");
        btn.type = "button";
        btn.className = "snize-info-icon";
        btn.setAttribute("aria-label", ariaFn(matchedKey));
        btn.setAttribute("aria-haspopup", "dialog");
        btn.innerHTML =
          '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M12 2a10 10 0 1 0 .001 20.001A10 10 0 0 0 12 2zm0 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm1 9h-2v-8h2v8z"></path></svg>' +
          '<span class="snize-info-text" style="line-height:1;">' +
          infoText +
          "</span>";

        span.insertAdjacentElement("afterend", btn);
      }

      if (!btn.dataset.bound) {
        btn.addEventListener("click", (ev) => {
          ev.stopPropagation();
          openInfo(matchedKey, desc);
        });
        btn.dataset.bound = "1";
      }

      PROCESSED.add(span);
      log(`Icon/Mehr-Infos (mobile) gesetzt an "${titleText}" → "${matchedKey}"`);
    });
  }

  function inject(scopes) {
    const dict = buildMap();
    if (!dict.size) {
      log("kein Mapping (FILTER_ICON_TEXTS leer)");
      return;
    }

    let roots;
    if (Array.isArray(scopes) && scopes.length) {
      roots = scopes.filter(Boolean);
    } else {
      roots = [document];
    }

    roots.forEach((root) => injectIntoScope(root, dict));
  }

  const onTranslated = (ev) => {
    const scopes = ev && ev.detail && ev.detail.scopes;
    [0, 120, 400, 900, 1800].forEach((d) =>
      setTimeout(() => inject(scopes), d)
    );
  };
  document.addEventListener("sr:filters:translated", onTranslated);
  window.addEventListener("sr:filters:translated", onTranslated);

  document.addEventListener("DOMContentLoaded", () => {
    [0, 300, 1200].forEach((d) => setTimeout(() => inject(), d));
  });
  window.addEventListener("load", () => {
    [0, 500].forEach((d) => setTimeout(() => inject(), d));
  });

  const bodyObs = new MutationObserver(() => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => inject(), 150);
  });
  bodyObs.observe(document.body, { childList: true, subtree: true });

  // für direkte Aufrufe aus deinem Übersetzungs-Script
  window.SRFilterInfoIcon = { inject };
})();
